import { RelayCommunicationSection, RelayUpdateSection } from '@nirvana/shared/dtos/types/policies/common';

// UI form value format
export interface RelayCommunicationFormValue {
  uiSettings: { relay: { communication: RelayCommunicationSection } };
}
export interface RelayUpdateFormValue {
  uiSettings: { relay: { update: RelayUpdateSection } };
}

// searchable keywords
export enum RelayCommunicationSearchableKeywords {
  Relay = 'Relay',
  Communication = 'Communication',
  AutomaticDiscovery = 'AutomaticDiscovery',
  CommunicationBetweenRelaysAndCloudServices = 'CommunicationBetweenRelaysAndCloudServices',
  CommunicationBetweenRelaysAndGz = 'CommunicationBetweenRelaysAndGz',
  WhitelistedDomains = 'WhitelistedDomains',
  UseProxy = 'UseProxy',
  DoNotUseProxy = 'DoNotUseProxy',
}
export enum RelayUpdateSearchableKeywords {
  Update = 'Update',
  CheckForUpdates = 'CheckForUpdates',
  DownloadFolder = 'DownloadFolder',
  UpdateLocations = 'UpdateLocations',
}
